import React, { useRef } from "react";
import { CurrentUser } from "../../graphQL/user/UserTypes";
import { userInfoVar } from "../../App";
import { useReactiveVar } from "@apollo/client";

let timeout: NodeJS.Timeout;

const useReactNativeUserSync = () => {
	const userInfo = useReactiveVar(userInfoVar);

	const rnNewUserInfoSync = useRef<string>();

	React.useEffect(() => {
		if (timeout) {
			clearInterval(timeout);
		}

		timeout = setInterval(() => {
			// alert(rnNewUserInfoSync);
			if (
				(window as any).ReactNativeInjectedUser &&
				rnNewUserInfoSync.current !==
					(window as any).ReactNativeInjectedUser?.time
			) {
				const currentUserInfo = {
					// just for fixing curren ios version
					...{
						affiliate: userInfo?.affiliate,
						claimNoAffiliate: userInfo?.claimNoAffiliate,
						myAffiliateId: userInfo?.myAffiliateId,
						verified: userInfo?.verified,
						emailVerified: userInfo?.emailVerified,
						phoneVerified: userInfo?.phoneVerified,
						status: userInfo?.status,
						languageLevel: userInfo?.languageLevel,
						subscriptionPlan: {
							...(userInfo?.subscriptionPlan || {}),
						},
					},
					...((window as any).ReactNativeInjectedUser || {}),
				};

				localStorage.setItem(
					"currentUserInfo",
					JSON.stringify(currentUserInfo)
				);

				userInfoVar(currentUserInfo);

				rnNewUserInfoSync.current = (
					window as any
				).ReactNativeInjectedUser?.time;
			}
		}, 100);

		return () => {
			clearInterval(timeout);
		};
	}, []);

	return null;
};

export default useReactNativeUserSync;
